export default __webpack_public_path__ + "static/media/shutterstock_33446842_good_food_safe_food.ba284e7b.webp";